import { createApiRef } from '@backstage/frontend-plugin-api';
import {
  Integration,
  IntegrationEntity,
} from '@internal/backstage-plugin-catalog-devops-module-integrations-common';
import { DefaultApiResponse } from '@internal/backstage-plugin-devops-react';

export const integrationsApiRef = createApiRef<IntegrationsApi>().with({
  id: 'integrations-api',
  pluginId: 'catalog-devops-module-integrations',
});

export interface IntegrationsApi {
  getIntegrations(): Promise<Integration[]>;
  getIntegration(integrationId: string): Promise<Integration>;
  createIntegrationEntity(data: Integration): Promise<DefaultApiResponse>;
  editIntegrationEntity(
    id: string,
    data: Integration,
  ): Promise<DefaultApiResponse>;
  deleteIntegrationEntity(id: string): Promise<DefaultApiResponse>;
  triggerProvider(providerType: string): Promise<DefaultApiResponse>;
  dryRun(data: IntegrationEntity): Promise<DefaultApiResponse>;
  run(data: IntegrationEntity): Promise<DefaultApiResponse>;
}
